import React, { useState, useEffect } from "react";
import { CardMedia } from "@mui/material";
import {
  CardNoImage,
  CardFallbackImage,
} from "Components/Module/LearningActivityItem/functions";
import { CARD_IMAGE_HEIGHT } from "Components/Module/LearningActivityItem/constants";

const CourseCardImage = ({
  imageUrl,
  title,
  displayImage,
  decorativeImage = false,
}) => {
  const [hasError, setHasError] = useState(false);
  const validImage = displayImage && !!imageUrl && imageUrl.trim() !== "";

  useEffect(() => {
    setHasError(false);
  }, [imageUrl]);
  const imageSx = validImage
    ? {
        height: CARD_IMAGE_HEIGHT,
      }
    : {
        height: CARD_IMAGE_HEIGHT,
        backgroundColor: "var(--colorCourseCardFallback)",
      };

  const handleError = () => {
    setHasError(true);
  };

  const imageAlt = decorativeImage ? "" : title;
  const fallbackTitle = decorativeImage ? "" : title;

  if (hasError) {
    return <CardFallbackImage title={fallbackTitle} />;
  }

  if (validImage) {
    return (
      <CardMedia
        component="img"
        height={CARD_IMAGE_HEIGHT}
        image={imageUrl}
        sx={imageSx}
        alt={imageAlt}
        loading="lazy"
        onError={handleError}
      />
    );
  }

  if (displayImage) {
    // Render a CardMedia with gray background when displayImage is true but no valid image
    return <CardMedia component="div" sx={imageSx} alt="" />;
  }

  return <CardNoImage />;
};

export default CourseCardImage;
